"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractSDK = void 0;
const typechain_1 = require("./typechain");
class ContractSDK {
    constructor(signerOrProvider, options) {
        this.signerOrProvider = signerOrProvider;
        this.options = options;
        this._contractDeployments =
            (options === null || options === void 0 ? void 0 : options.deploymentDetails) || require(`./publish/${(options === null || options === void 0 ? void 0 : options.network) || 'testnet'}.json`);
        this._isReady = this._init().then(() => this);
    }
    static async create(signerOrProvider, options) {
        const sdk = new ContractSDK(signerOrProvider, options);
        return sdk.isReady;
    }
    get settings() {
        if (!this._settings) {
            throw new Error(`_settings address not found`);
        }
        return this._settings;
    }
    get sqToken() {
        if (!this._sqToken) {
            throw new Error(`sqToken address not found`);
        }
        return this._sqToken;
    }
    get staking() {
        if (!this._staking) {
            throw new Error(`_staking address not found`);
        }
        return this._staking;
    }
    get stakingManager() {
        if (!this._stakingManager) {
            throw new Error(`_stakingManager address not found`);
        }
        return this._stakingManager;
    }
    get indexerRegistry() {
        if (!this._indexerRegistry) {
            throw new Error(`_indexerRegistry address not found`);
        }
        return this._indexerRegistry;
    }
    get queryRegistry() {
        if (!this._queryRegistry) {
            throw new Error(`_queryRegistry address not found`);
        }
        return this._queryRegistry;
    }
    get inflationController() {
        if (!this._inflationController) {
            throw new Error(`_inflationController address not found`);
        }
        return this._inflationController;
    }
    get serviceAgreementRegistry() {
        if (!this._serviceAgreementRegistry) {
            throw new Error(`_serviceAgreementRegistry address not found`);
        }
        return this._serviceAgreementRegistry;
    }
    get eraManager() {
        if (!this._eraManager) {
            throw new Error(`_eraManager address not found`);
        }
        return this._eraManager;
    }
    get planManager() {
        if (!this._planManager) {
            throw new Error(`_planManager address not found`);
        }
        return this._planManager;
    }
    get rewardsDistributor() {
        if (!this._rewardsDistributor) {
            throw new Error(`_rewardsDistributer address not found`);
        }
        return this._rewardsDistributor;
    }
    get rewardsPool() {
        if (!this._rewardsPool) {
            throw new Error(`_rewardsPool address not found`);
        }
        return this._rewardsPool;
    }
    get rewardsStaking() {
        if (!this._rewardsStaking) {
            throw new Error(`_rewardsStaking address not found`);
        }
        return this._rewardsStaking;
    }
    get rewardsHelper() {
        if (!this._rewardsHelper) {
            throw new Error(`_rewardsHelper address not found`);
        }
        return this._rewardsHelper;
    }
    get purchaseOfferMarket() {
        if (!this._purchaseOfferMarket) {
            throw new Error(`_purchaseOfferMarket address not found`);
        }
        return this._purchaseOfferMarket;
    }
    get isReady() {
        return this._isReady;
    }
    get stateChannel() {
        if (!this._stateChannel) {
            throw new Error(`_stateChannel address not found`);
        }
        return this._stateChannel;
    }
    get airdropper() {
        if (!this._airdropper) {
            throw new Error(`_airdropper address not found`);
        }
        return this._airdropper;
    }
    get permissionedExchange() {
        if (!this._permissionedExchange) {
            throw new Error(`_permissionedExchange address not found`);
        }
        return this._permissionedExchange;
    }
    get consumerHost() {
        if (!this._consumerHost) {
            throw new Error(`_consumerHost address not found`);
        }
        return this._consumerHost;
    }
    get disputeManager() {
        if (!this._disputeManager) {
            throw new Error(`_disputeManager address not found`);
        }
        return this._disputeManager;
    }
    get proxyAdmin() {
        if (!this._proxyAdmin) {
            throw new Error('_proxyAdmin address not found');
        }
        return this._proxyAdmin;
    }
    get vesting() {
        if (!this._vesting) {
            throw new Error('_vesting address not found');
        }
        return this._vesting;
    }
    async initContract(factory, address) {
        if (!address) {
            return undefined;
        }
        return factory.connect(address, this.signerOrProvider);
    }
    async _init() {
        var _a, _b, _c, _d, _e, _f;
        const [settings, sqToken, staking, stakingManager, indexerRegistry, queryRegistry, inflationController, serviceAgreementRegistry, eraManager, planManager, rewardsDistributor, rewardsPool, rewardsStaking, rewardsHelper, purchaseOfferMarket, stateChannel, airdropper, permissionedExchange, consumerHost, disputeManager, proxyAdmin, vesting] = await Promise.all([
            this.initContract(typechain_1.Settings__factory, (_a = this._contractDeployments.Settings) === null || _a === void 0 ? void 0 : _a.address),
            this.initContract(typechain_1.SQToken__factory, (_b = this._contractDeployments.SQToken) === null || _b === void 0 ? void 0 : _b.address),
            this.initContract(typechain_1.Staking__factory, (_c = this._contractDeployments.Staking) === null || _c === void 0 ? void 0 : _c.address),
            this.initContract(typechain_1.StakingManager__factory, (_d = this._contractDeployments.StakingManager) === null || _d === void 0 ? void 0 : _d.address),
            this.initContract(typechain_1.IndexerRegistry__factory, (_e = this._contractDeployments.IndexerRegistry) === null || _e === void 0 ? void 0 : _e.address),
            this.initContract(typechain_1.QueryRegistry__factory, (_f = this._contractDeployments.QueryRegistry) === null || _f === void 0 ? void 0 : _f.address),
            this.initContract(typechain_1.InflationController__factory, this._contractDeployments.InflationController.address),
            this.initContract(typechain_1.ServiceAgreementRegistry__factory, this._contractDeployments.ServiceAgreementRegistry.address),
            this.initContract(typechain_1.EraManager__factory, this._contractDeployments.EraManager.address),
            this.initContract(typechain_1.PlanManager__factory, this._contractDeployments.PlanManager.address),
            this.initContract(typechain_1.RewardsDistributer__factory, this._contractDeployments.RewardsDistributer.address),
            this.initContract(typechain_1.RewardsPool__factory, this._contractDeployments.RewardsPool.address),
            this.initContract(typechain_1.RewardsStaking__factory, this._contractDeployments.RewardsStaking.address),
            this.initContract(typechain_1.RewardsHelper__factory, this._contractDeployments.RewardsHelper.address),
            this.initContract(typechain_1.PurchaseOfferMarket__factory, this._contractDeployments.PurchaseOfferMarket.address),
            this.initContract(typechain_1.StateChannel__factory, this._contractDeployments.StateChannel.address),
            this.initContract(typechain_1.Airdropper__factory, this._contractDeployments.Airdropper.address),
            this.initContract(typechain_1.PermissionedExchange__factory, this._contractDeployments.PermissionedExchange.address),
            this.initContract(typechain_1.ConsumerHost__factory, this._contractDeployments.ConsumerHost.address),
            this.initContract(typechain_1.DisputeManager__factory, this._contractDeployments.DisputeManager.address),
            this.initContract(typechain_1.ProxyAdmin__factory, this._contractDeployments.ProxyAdmin.address),
            this.initContract(typechain_1.Vesting__factory, this._contractDeployments.Vesting.address)
        ]);
        this._settings = settings;
        this._sqToken = sqToken;
        this._staking = staking;
        this._stakingManager = stakingManager;
        this._indexerRegistry = indexerRegistry;
        this._inflationController = inflationController;
        this._queryRegistry = queryRegistry;
        this._serviceAgreementRegistry = serviceAgreementRegistry;
        this._eraManager = eraManager;
        this._planManager = planManager;
        this._rewardsDistributor = rewardsDistributor;
        this._rewardsPool = rewardsPool;
        this._rewardsStaking = rewardsStaking;
        this._rewardsHelper = rewardsHelper;
        this._purchaseOfferMarket = purchaseOfferMarket;
        this._stateChannel = stateChannel;
        this._airdropper = airdropper;
        this._permissionedExchange = permissionedExchange;
        this._consumerHost = consumerHost;
        this._disputeManager = disputeManager;
        this._proxyAdmin = proxyAdmin;
        this._vesting = vesting;
    }
}
exports.ContractSDK = ContractSDK;
